import React from 'react'
import { getClassNames } from '../../_utils/classnames'
import { MacroSelectOptionProps } from './types'
import { MACRO_MGR_BASE_CLASSNAME } from './constants'
import { CheckCircleOutlined } from '@ant-design/icons'

export const MacroSelectOption = ({ macro, onClick, context }: MacroSelectOptionProps) => {
    let isActive = context?.macro?.value?.trim() === macro.value.trim()

    return (
        <li
            className={getClassNames(`${MACRO_MGR_BASE_CLASSNAME}-item`, {
                ['active']: isActive,
            })}
            onClick={(e) => {
                e.preventDefault()
                onClick(macro)
            }}
        >
            <span className="label">{macro.label}</span>
            {isActive && (
                <span className="active-indicator">
                    <CheckCircleOutlined />
                </span>
            )}
        </li>
    )
}
